<template>

<div class="input-group w-100">

    <!-- label-key="RequestDetailedDescription" -->

    

    <kt-select
        :label="props.label"
        placeholder="Choose client then select a job"
        
        :label-callback="customJobLabel"
        value-key="Id"
        :limit="50"
        :options="list"
        v-model="model"
        class="flex-grow-1"
        suffix-class="p-0"
        :input-class="props.inputClass"
        @change="$emit('change', $event)"
    >


        <template #suffix>

            <!-- filter jobs -->
            <kt-multi-select
                css="rounded-0"
                placeholder="<i class='fa fa-filter'></i>"
                :options="statusOptions"
                labelKey="Status"
                valueKey="Id"
                v-model="statusFilter"
            >
            </kt-multi-select>

            <!-- edit job -->
            <button 
                v-if="model"
                class="btn btn-outline-secondary btn-sm mt-auto rounded-start-0 rounded-end-0" 
                @click="editJob(model)"
            ><i class="fa fa-edit"></i>
            </button>

            <!-- new job -->
            <button 
                class="btn btn-outline-primary btn-sm mt-auto rounded-start-0" 
                @click="editJob()"
            ><i class="fa fa-plus"></i>
            </button>

        </template>

    </kt-select>

</div>

<kt-modal
    :title="formTitle"
    :visible="formVisible"
    :size="'modal-xl'"
    @dismiss="formDismiss()"
>
    <template #body>
        <job-form
            v-model="form"
        ></job-form>
    </template>

    <template #footer>
        <div class="container-fluid px-0">
            <div class="row">
                <div class="col">
                    <button 
                        @click="formDismiss()" 
                        class="btn btn-secondary form-control"
                    >Close</button>
                </div>
                <!-- deletion button ...
                <div class="col-4" v-if="extraRecord.Id">
                    <button @click="extraDelete()" class="btn btn-danger form-control">Delete</button>
                </div>
                -->
                <div class="col">
                    <button 
                        @click="formSave(form)" 
                        class="btn btn-primary form-control"
                    >Save</button>
                </div>
            </div>
        </div>
    </template>
</kt-modal>
    
</template>
    
<script setup>

/*

TODO - Update to use a custom select component

*/

import { ref, watch, onUnmounted, onMounted } from "vue";
import { useJobStatusStore } from "@/stores/JobStatusStore";
import { storeToRefs } from "pinia";

import Api from "@/services/Api";
import ApiService from "@/services/ApiService";
import KtSelect from "@/components/UI/KtSelect.vue";
import KtMultiSelect from "@/components/UI/KtMultiSelect.vue";
import KtModal from "@/components/UI/KtModal.vue";
import JobForm from "@/components/Jobs/JobForm.vue";

const model = defineModel(
{
    type: String,
    default: "",
});


const props = defineProps(
{ 
    "label": {
        type: String,
        default: "Select job"
    },
    
    "client": {
        type: String,
        default: ""
    },
    
    "inputClass": {
        type: String,
        default: ""
    },
    
    "includePMs": {
        type: Boolean,
        default: false
    },
    
    // deprecated ...
    "status": {
        type: Array,
        default: []
    },
    
});

const emits = defineEmits(["change"]);
const jobStatusStore = useJobStatusStore();

const { list: statusOptions } = storeToRefs(jobStatusStore);
const statusFilter = ref([]);

const list = ref([]);
const form = ref({});
const formTitle = ref("New Job");
const formVisible = ref(false);
const options = jobStatusStore.list;

const unwatch = [];

const customJobLabel = (row) =>
{
    // format should be STATUS - JobId - Description

    let name = row.RequestDetailedDescription 
        || row.TaskDetail
        || "Description Not Set";

    for (let i = 0; i < jobStatusStore.list.length; i++)
    {
        let tmp = jobStatusStore.list[i];
        if (tmp.Id === row.RequestStatus)
        {
            name = tmp.Status + " - " + name;
            break;
        }
    }

    let id = row.Id;
    name = id + " | " + name;

    return name;
};

const loadJobs = async () =>
{
    if (!props.client)
    {
        list.value = [];
        model.value = "";
        return;
    }

    let status = undefined;
    
    if (props.status?.length)
    {
        status = (props.status + "").split(",");
    }

    if (statusFilter.value)
    {
        status = statusFilter.value;
    }

    list.value = await Api.loadJobs({ 
        CustomerNumber: props.client, 
        Size: 9999999,
        Status: status,
        IncludePMs: props.includePMs
    });
};

const editJob = async (val) =>
{
    if (val)
    {
        formTitle.value = "Edit Request";
        form.value = await ApiService.loadRequest(val);
    }

    else
    {
        form.value = {};

        if (props.client)
        {
            formTitle.value = "New Request";
            form.value.Customer = props.client;
        }
    }

    formVisible.value = 1;
};

unwatch.push(watch (() => props.client, async (nv, ov) =>
{
    await loadJobs();
    let list = await jobStatusStore.load();

    // console.debug("list", list);
    // console.debug("list2", jobStatusStore.list);
}, 
{
    immediate: true
}));

unwatch.push(watch(() => statusFilter.value, async (nv, ov) => {
    await loadJobs();
}));

const formDismiss = () =>
{
    formVisible.value = 0;
};

const formSave = async (rec) =>
{
    await Api.saveJob(rec);
    await loadJobs();
    formVisible.value = 0;
};

onMounted(async () =>
{
    await jobStatusStore.load();
});

onUnmounted(() =>
{
    unwatch.forEach((val) => {
        val();
    });
});
    
</script>